"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutForPaymentPath = exports.getCheckoutForPayment = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const getCheckoutForPayment = (client) => async ({ checkoutId }) => {
    try {
        const response = await client.get((0, exports.getCheckoutForPaymentPath)(checkoutId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getCheckoutForPayment = getCheckoutForPayment;
const getCheckoutForPaymentPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/for-payment`;
exports.getCheckoutForPaymentPath = getCheckoutForPaymentPath;
